var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3799,
    height: 794,
    viewBox: "-40 -40 3799 794",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "L3 Route") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Custom outlined geometric wordmark in blue #009FE0. Transparent background.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009FE0",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "glyph-L",
    transform: "translate(0 0)",
    d: "M0 0H142V558H470V700H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "glyph-3",
    transform: "translate(500 0)",
    d: "M34 0H372C448 0 498 42 498 101C498 134 481 162 451 190L342 291C452 311 520 382 520 488C520 620 413 714 261 714C112 714 9 623 0 487H141C148 548 192 585 263 585C335 585 379 548 379 492C379 433 332 399 253 399H146V298L326 132H34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "glyph-R",
    transform: "translate(1150 0)",
    d: "M0 0H293C470 0 573 82 573 222C573 326 516 396 419 427L612 700H443L270 446H142V700H0ZM142 132V319H288C379 319 430 286 430 223C430 162 379 132 288 132Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "glyph-o",
    transform: "translate(1757 0)",
    d: "M260 190C412 190 523 300 523 452C523 604 412 714 260 714C108 714 0 604 0 452C0 300 108 190 260 190ZM260 318C181 318 137 374 137 452C137 530 181 586 260 586C340 586 386 530 386 452C386 374 340 318 260 318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "glyph-u",
    transform: "translate(2315 0)",
    d: "M0 204H137V481C137 550 172 587 234 587C301 587 343 542 343 469V204H480V700H349V645C314 690 265 714 201 714C75 714 0 634 0 497Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "glyph-t",
    transform: "translate(2830 0)",
    d: "M62 84H199V204H332V324H199V515C199 566 225 588 270 588C294 588 315 584 334 578V696C308 707 276 714 244 714C124 714 62 651 62 532V324H0V204H62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "glyph-e",
    transform: "translate(3204 0)",
    d: "M511 487H138C153 553 201 591 270 591C327 591 371 570 407 532L498 618C442 681 366 714 265 714C109 714 0 608 0 453C0 303 108 190 257 190C406 190 515 299 515 456C515 467 514 478 511 487ZM138 381H376C359 329 317 301 258 301C201 301 156 330 138 381Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a2ec4edee50dce6a1c7c4607375ae14.svg";
export { ForwardRef as ReactComponent };